import React, { useState } from "react";
import Media from "@qlik/qlik/src/components/Media";
import { handleKeyboardEventBehavior } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";
import { useI18n } from "@qlik/utils/i18nContext";
import { useLanguageSwitcher } from "../Header/LanguageSelector";

const LanguageOptions = ({ languages }) => {
    return (
        <div className={styles.languageSwitcher}>
            <div
                className={`${styles.languageOptions} absolute w-full bottom-14 bg-white border border-stone rounded-xs`}
            >
                <ul className="py-2.5 px-2.5">
                    {languages.map((language) => (
                        <li
                            className={`text-xs text-gray font-medium leading-relaxed p-1.25 hover:bg-light-casper hover:rounded-xs cursor-pointer transition-all ${
                                language.isActive ? styles.active : ""
                            }`}
                            key={language.langCode}
                            data-lang-key={language.langCode}
                        >
                            <a href={language.destination} target="_self" className="block" tabindex="-1">
                                {language.langName}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

const LanguageSwitcher = ({ className }) => {
    const { i18n } = useI18n();

    // Define the languages for the language switcher
    const languages = useLanguageSwitcher(i18n);
    const [isActive, setIsActive] = useState(false);

    const activeLanguage = languages.find((x) => x.isActive);

    const handleLanguageDropdown = () => {
        setIsActive(!isActive);
    };

    return (
        <div className={className}>
            <div className={`relative cursor-pointer ${styles.languageSwitcher} ${isActive ? styles.active : ""}`}>
                {isActive && <LanguageOptions languages={languages} />}
                {activeLanguage && (
                    <div
                        role="button"
                        tabIndex={-1}
                        onKeyDown={(e) => {
                            handleKeyboardEventBehavior(e, handleLanguageDropdown);
                        }}
                        onClick={handleLanguageDropdown}
                        className={`${styles.languageBtn} flex gap-3.75 h-[46px] items-center top-0 left-0 w-full px-3.75 py-3 bg-stone-light`}
                    >
                        <span className="flex-grow text-xs text-gray leading-relaxed select-none">
                            {activeLanguage?.langName}
                        </span>
                        <i className={` ${styles.dropdownIcon} dropdown-icon`} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default LanguageSwitcher;
